import { Mail, Phone, Globe } from 'lucide-react'
import { OnGuardMark, DCUC_EMAIL, DCUC_PHONE, DCUC_PHONE_HREF } from './brand'

/** Footer for the OnGuard | ScamDefense DCUC pitch. */
export default function DcucFooter() {
  return (
    <footer className="bg-[#0a1733] text-white">
      <div className="h-1 w-full bg-[#c8102e]" />
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <OnGuardMark className="text-xl" />
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white/80">
            <a href={`mailto:${DCUC_EMAIL}`} className="inline-flex items-center gap-2 hover:text-white">
              <Mail className="h-4 w-4 text-[#ff5c6e]" />
              {DCUC_EMAIL}
            </a>
            <a href="https://scamdefense.org" className="inline-flex items-center gap-2 hover:text-white">
              <Globe className="h-4 w-4 text-[#ff5c6e]" />
              scamdefense.org
            </a>
            <a href={DCUC_PHONE_HREF} className="inline-flex items-center gap-2 hover:text-white">
              <Phone className="h-4 w-4 text-[#ff5c6e]" />
              {DCUC_PHONE}
            </a>
          </div>
        </div>
        <p className="mt-8 border-t border-white/10 pt-6 text-xs text-white/50">
          &copy; {new Date().getFullYear()} ScamDefense. Educational content. Not legal or financial advice.
        </p>
      </div>
    </footer>
  )
}
